<template>
  <div class="invite "> 
     <div class="content width1120">
     	<div class="center">
     		<div class="top">
     		</div>
     		<div class="body">
     			<div class="item-title">参与步骤</div>
     			<div class="step-wrap">
     				<div class="step">
     					<img src="../assets/img/i-icon1.svg" alt="">
     					<span>邀请好友</span>
     				</div>
     				<div class="step-line"></div>
     				<div class="step">
     					<img src="../assets/img/i-icon2.svg" alt="">
     					<span>好友注册</span>
     				</div>
     				<div class="step-line"></div>
     				<!-- <div class="step">
     					<img src="../assets/img/i-icon3.svg" alt="">
     					<span>绑定手机</span>
     				</div>
     				<div class="step-line"></div> -->
     				<div class="step">
     					<img src="../assets/img/i-icon4.svg" alt="">
     					<span>奖励到账</span>
     				</div> 
     			</div>
     			<a class="btn" href="https://hanabi.data-viz.cn/login#usePhone">立即参与</a> 
                <div class="hr"></div>
                <div class="detail">
                	<p class="detail-title">
                		邀请规则说明
                	</p>
                	<div class="detail-item">
                		<div class="detail-circle"></div>
                		<p>
                			同一登录账号、同一手机号、同一终端设备号或其他会合理显示为同一用户的情形，均视为同一用户，不可互相邀请
                		</p>
                	</div>
                	<div class="detail-item">
                		<div class="detail-circle"></div>
                		<p>
                			怎么算邀请成功？
                		</p>
                	</div>
                	<div class="detail-item">
                		<div class="detail-circle blue"></div>
                		<p>
                			邀请对象为从未在花火Hanabi注册的新用户
                		</p>
                	</div>
                	<div class="detail-item">
                		<div class="detail-circle blue"></div>
                		<p>
                			好友需要通过分享链接（或二维码）接受邀请注册，并在活动期间内注册成功并绑定手机号
                		</p>
                	</div>
                	<div class="detail-item">
                		<div class="detail-circle blue"></div>
                		<p>
                			若通过不正当手段获取奖励，经查实花火Hanabi有权撤销该用户的活动资格并取消其奖励
                		</p>
                	</div>
                  <div class="detail-item">
                    <div class="detail-circle"></div>
                    <p>
                      邀请成功会获得什么？
                    </p>
                  </div>
                  <!-- <div class="detail-item">
                    <div class="detail-circle blue"></div>
                    <p>
                      邀请的好友注册成功且绑定手机号，您和好友都将获得5天视频会员
                    </p>
                  </div> -->
                  <div class="detail-item">
                    <div class="detail-circle blue"></div>
                    <p>
                     累计成功邀请5名好友，您可额外获得5天视频会员
                    </p>
                  </div> 
                  <!-- <div class="detail-item">
                    <div class="detail-circle"></div>
                    <p>
                     活动截止日期：2020年4月30日
                    </p>
                  </div>  -->
                </div>
     		</div>
     	</div>
     </div> 
     <p class="copyRight">Copyright © 2020 hanabi.cn. All Rights Reserved. <span class="icp" @click="goICP">京ICP备17016840号-3</span></p>
  </div>
</template>


<script>
 
export default {
  name: "chart",
  data() {
    return {
        
    };
  },
  methods: { 
    goICP(){
      window.open('http://www.beian.miit.gov.cn')
    },
  }, 
  mounted() {
     
  },
  created(){
    this.$http.get(localStorage.apiUrl+"/api/ulog/fetch?url=a/idx/btn&referer=join");
  } 
};
</script>
<style scoped>
.invite{
	position: relative;
} 
 .content{
 	background-color:#f5f5f7;
 	padding:50px 0 60px;
 }
 .center{
 	width:720px;
 	margin: 0 auto; 
 }
 .top{
 	height: 262px;
 	padding-top:170px;
 	background: url('http://hanabi.data-viz.cn/static/img/i_timeout.8fb5c04.svg') no-repeat center center/100%;;
 }
 .top p{
 	font-size: 14px;
    color: #FFFFFF;
 	text-align: center;
 	line-height: 20px;
 }
 .body{
 	background: #FFFFFF;
    border-radius: 24px 24px 0 0; 
    padding: 28px 0 48px;
    position: relative;
    top: -24px;
 }
 .item-title{
 	text-align: center;
 	font-size: 18px;
    color: #0423A5;
    line-height: 25px;
 }
 .item-title:after{
   display: block;
   content: '';
   margin: 4px auto 0;
   width:19px;
   height:3px;
   background: #06E9EF;
 }
 .step-wrap{
 	width: 480px;
 	margin: 30px auto 70px; 
 	display: flex;
 	justify-content: space-between;
 	align-items: center;
 }
 .step{
 	width: 60px;
 	height: 60px;
 	background: #0423A5;
 	border-radius:30px;
 	text-align: center;
 	font-size: 14px;
    color: #445B84; 
 }
 .step span{
 	margin-top: 10px;
 	line-height: 20px;
 }
 .step-line{
 	width: 65px;
 	border-bottom: 1px dashed #0423A5;
 }
 .btn{
 	display: block;
 	width: 120px;
 	height: 42px;
 	margin: 0 auto;
 	line-height: 42px;
 	text-align: center;
 	cursor: pointer;
 	font-size: 20px;
 	background: #0423A5;
 	color: #fff;
 	box-shadow: 0 4px 8px 0 rgba(191,191,191,0.60);
	border-radius: 4px;
 }
 .hr{
 	width: 680px;
 	margin: 54px auto 24px;
 	border: 1px solid #E4E7EF;
 }
 .detail{
 	width:600px;
 	margin: 0 auto;
 }
 .detail-title{
 	line-height: 40px;
 	font-size: 14px;
    color: #8FA1BC;
 }
 .detail-item{ 
  position: relative;
  padding-left: 15px;
 	  font-size: 12px;
    color: #8FA1BC;
    line-height: 17px;
 }
 .detail-circle{
  position: absolute;
 	width: 5px;
 	height: 5px; 
  left: 5px;
  top: 6px;
 	border-radius: 50%;
 	border: 1px solid #445B84;
 	background: #fff;
 }
 .blue{ 
  width: 4px;
  height: 4px; 
  left: 20px;
  top: 7px;
 	background: #445B84;
 }
 .blue + p{
  margin-left: 15px;
 }
 .copyRight{ 
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color:#0423a5;
}
@media screen and (max-width:600px){ 
  .title{
    display: none;
  }
  .content{
    padding: 0;
  }
  .center{
    width: 100%;
    background: #fff;
  }
  .top{
    padding: 0;
    height: 7.56rem;
    background: url(http://hanabi.data-viz.cn/static/img/i_timeout2.4e472f5.svg) no-repeat center center/cover;
  }
  .body{
    padding: 0.666667rem 0 0.746667rem;
  }
  .item-title{
    font-size: 0.48rem;
    line-height: 0.666667rem;
  }
  .item-title:after{
    width: 0.48rem;
    height: 0.08rem;
  }
  .step-wrap{
    width: 100%;
    margin-top: 0.84rem;
    justify-content: center;
  }
  .step{
    width: 1.333333rem;
    height: 1.333333rem;
  }
  .step img{
    width: 100%;
    height: 100%;
  }
  .step-line{
    width: 0.573333rem;
    margin: 0 0.24rem;
  }
  .step span{
    font-size: 0.32rem;
  } 
  .hr{
    width: 9.333333rem;
    margin: 1.013333rem auto 0.666667rem;
  }
  .btn{
  	width: 2.8rem;
  	height: 0.96rem;
  	line-height: 1rem;
  	font-size: 0.5rem;
  }
  .detail{
    width: 100%;
    padding: 0 0.4rem;
    font-size: 0.32rem;
    line-height: 0.4rem;
  }
  .detail-title{
    font-size: 0.32rem;
    line-height: 0.44rem;
    margin-bottom: 0.16rem;
  }
  .detail-item{
    font-size: 0.293333rem;
    line-height: 0.4rem;
  }
  .copyRight{
    font-size: 10px; 
  }
}
</style>

